import React from 'react';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import { compose, withHandlers, setPropTypes, lifecycle } from 'recompose';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ENTER_KEY_NAME, ESCAPE_KEY_NAME } from '@mm/constants/keys-codes';
import Button from '../../../common/buttons/DeprecatedButton/DeprecatedButton';
import updateListener from '../../../common/helpers/utils/EventListenerUtils';
import './ConfirmDeleteModal.scss';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';

const propTypes = {
  headerText: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    .isRequired,
  show: PropTypes.bool.isRequired,
  // onCloseLocal: PropTypes.func.isRequired,
  // onDeleteLocal: PropTypes.func.isRequired,
  // onKeyDown: PropTypes.func.isRequired,
  children: PropTypes.node,
};

const ConfirmDeleteModalBase = ({
  headerText,
  show,
  onCloseLocal,
  onDeleteLocal,
  children,
}) => (
  <Modal isOpen={show} className="modal-component">
    <ModalBody>
      <h3>{headerText}</h3>

      <div className="modal-component__body-text">{children}</div>
    </ModalBody>
    <ModalFooter>
      <Button onClick={onCloseLocal} invert small>
        Cancel
      </Button>
      <Button autoFocus="true" onClick={onDeleteLocal} small red>
        Delete
      </Button>
    </ModalFooter>
  </Modal>
);

function componentWillReceiveProps(nextProps) {
  const { show, onKeyDown } = this.props;
  updateListener(nextProps.show, show, 'keydown', onKeyDown);
}

function componentWillUnmount() {
  updateListener(false, true, 'keydown', this.props.onKeyDown);
}

const onDeleteLocal =
  ({ onDelete, selectedEntityId, onClose, chatbotId }) =>
  e => {
    e.preventDefault();
    onDelete(chatbotId, selectedEntityId);
    onClose();
  };

const onCloseLocal =
  ({ onClose }) =>
  () => {
    onClose();
  };

const onKeyDown =
  ({ onCloseLocal, onDeleteLocal }) =>
  e => {
    if (e.key === ESCAPE_KEY_NAME) {
      onCloseLocal();
    }
    if (e.key === ENTER_KEY_NAME) {
      onDeleteLocal(e);
      e.preventDefault();
    }
  };

const mapStateToProps = state => ({
  chatbotId: activeChatbotIdSelector(state),
});

const enhance = compose(
  setPropTypes(propTypes),
  connect(mapStateToProps),
  withHandlers({ onDeleteLocal, onCloseLocal }),
  withHandlers({ onKeyDown }),
  lifecycle({ componentWillReceiveProps, componentWillUnmount }),
);

export default enhance(ConfirmDeleteModalBase);
